import React, { useContext, useEffect, useState } from "react";
import { Button, Input, Select } from "antd";
import "./EditColaboradorAdmin.css";
import axios from "axios";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { Link, useNavigate, useLocation } from "react-router-dom";
import * as links from "../../../../../utils/links";
import LoadingAction from "../../../../../themes/LoadingAction/LoadingAction";
import question_icon from "../../../../../assets/images/question.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { useParams } from "react-router-dom";
import { SERVIDOR_URL } from "../../../../../utils/constants";

const EditColaboradorAdmin = (props) => {
  const { Option } = Select;
  const { authInfo, setDataUser, setNotiMessage } = useContext<any>(AuthContext);
  const navigate = useNavigate();
  const token = authInfo?.dataUser?.token;
  const { id } = useParams();
  const location = useLocation();

  const routeState = (location.state as any) ?? {};
  const colaborador = routeState.colaborador ?? {};
  const clienteInfo = routeState.clienteInfo ?? {};

  const dateFormat = "YYYY-MM-DD";
  let currentDate = moment();

  const [data, setData] = useState<any>({
    nome: colaborador.nome ?? "",
    cpf: colaborador.cpf ?? "",
    status: colaborador.status ?? "ATIVO",
    dataVencimento: currentDate.add(1, "years"),
    permissao: colaborador.permissao ?? "",
    senha: "",
    valorCortesia: parseInt(colaborador.valorCortesia ?? "0")
  });

  const [errors, setErrors] = useState<any>({});
  const [isLoading, setIsLoading] = useState<any>(false);

  useEffect(() => {
    if (!routeState.colaborador || !clienteInfo.id || !id) {
      navigate(links.DASHBOARD_CLIENTES, { replace: true });
    }
  }, [clienteInfo.id, id, navigate, routeState.colaborador]);
  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const onSave = () => {
    let errorsTemp: any = {};
    if (data.nome.trim() === "") {
      errorsTemp.nome = "Este campo é obrigatório";
    }
    if (data.cpf.trim() === "" || data.cpf.length < 11) {
      errorsTemp.cpf = "Este campo é obrigatório e deve conter 11 digitos";
    }

    if (data.valorCortesia <= 0) {
      errorsTemp.valorCortesia = "Este campo é obrigatório";
    }

    if (data.permissao.trim() === "") {
      errorsTemp.nome = "Este campo é obrigatório";
    }

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);
    axios.put(
      `${SERVIDOR_URL}/colaborador-admin`,
      {
        id: id,
        nome: data.nome,
        cpf: data.cpf,
        clienteId: authInfo.dataUser?.id,
        status: data.status,
        permissao: data.permissao,
        senha: data.senha,
        valorCortesia: parseInt(data.valorCortesia)
      },
      {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      }
    ).then((res) => {
      setIsLoading(false);
      navigate(`${links.LISTA_COLABORADORES_ADMIN}/${clienteInfo.id}`, {
        state: clienteInfo,
      })
    }).catch((err) => {
      setIsLoading(false);

      setNotiMessage({
        type: "error",
        message: err.response?.data?.error
          ? err.response?.data?.error
          : `A sua sessão expirou, para continuar faça login novamente.`,
      });
    });
  };

  const handleGeneratePassword = () => {
    handleChange("senha", String(Math.floor(100000 + Math.random() * 9000)));
  };

  return (
    <>
      {isLoading && <LoadingAction />}
      <div className="AddCliente_container">
        <div className="AddCliente_header">
          <div className="AddCliente_header_title">Atualizar Colaborador - {data.nome}</div>
          <button className="custom-btn btn btn-outline-secondary"
            onClick={() =>
              navigate(`${links.LISTA_COLABORADORES_ADMIN}/${clienteInfo.id}`, {
                state: clienteInfo,
              })
            }>VOLTAR</button>
        </div>
        <div className="AddCliente_content">
          <div className="AddCliente_itemFieldMercadoPago">
            <label className="AddCliente_itemFieldLabel" htmlFor="nome">
              Nome:
            </label>
            <Input
              placeholder={"Jukinha da Silva"}
              value={data.nome}
              id="nome"
              type="text"
              name="nome"
              autoComplete="nome"
              onChange={(event) => {
                handleChange("nome", event.target.value);
              }}
              className={`${!!errors.nome ? "AddCliente_inputError" : ""}`}
            />
            {errors.nome && (
              <div className="AddCliente_itemFieldError">{errors.nome}</div>
            )}
          </div>

          <div className="AddCliente_itemFieldMercadoPago">
            <label className="AddCliente_itemFieldLabel" htmlFor="cpf">
              CPF:
            </label>
            <Input
              placeholder={"000.000.000-00"}
              value={data.cpf}
              id="cpf"
              type="text"
              name="cpf"
              autoComplete="cpf"
              onChange={(event) => {
                handleChange("cpf", event.target.value);
              }}
              className={`${!!errors.cpf ? "AddCliente_inputError" : ""}`}
            />
            {errors.cpf && (
              <div className="AddCliente_itemFieldError">{errors.cpf}</div>
            )}
          </div>
          <div className="AddCliente_itemFieldMercadoPago">
            <div className="AddCliente_Label_Icon">
              <label
                className="AddCliente_itemFieldLabel"
                htmlFor="mercadoPagoToken"
              >
                Senha
              </label>
              <Button
                style={{ margin: "10px 15px" }}
                onClick={handleGeneratePassword}
              >
                <FontAwesomeIcon
                  icon={faArrowsRotate}
                  style={{ marginRight: "5px" }}
                />
                Gerar Senha
              </Button>
            </div>

            <Input
              placeholder={"********"}
              value={data.senha}
              id="senha"
              type="text"
              name="senha"
              autoComplete="senha"
              onChange={(event) => {
                handleChange("senha", event.target.value);
              }}
              className={`${!!errors.senha ? "AddCliente_inputError" : ""}`}
            />
            {errors.senha && (
              <div className="AddCliente_itemFieldError">{errors.senha}</div>
            )}
          </div>
          <div className="AddCliente_itemFieldMercadoPago">
            <label className="AddCliente_itemFieldLabel" htmlFor="cpf">
              Valor da Cortesia
            </label>
            <Input
              placeholder={"R$0,00"}
              value={data.valorCortesia}
              id="valorCortesia"
              type="number"
              name="valorCortesia"
              autoComplete="valorCortesia"
              onChange={(event) => {
                handleChange("valorCortesia", event.target.value);
              }}
              className={`${!!errors.valorCortesia ? "AddCliente_inputError" : ""}`}
            />
            {errors.valorCortesia && (
              <div className="AddCliente_itemFieldError">{errors.valorCortesia}</div>
            )}
          </div>
          <div className="AddCliente_itemFieldMercadoPago">
            <label className="AddCliente_itemFieldLabel" htmlFor="status">
              Status:
            </label>
            <Select
              value={data.status}
              defaultValue={data.status}
              style={{ border: "1px solid", borderRadius: "4px", width: 288 }}
              onChange={(event) => {
                handleChange("status", event);
              }}
            >
              <Option value="ATIVO">Ativo</Option>
              <Option value="INATIVO">Inativo</Option>
            </Select>
            {errors.tipo && (
              <div className="AddCliente_itemFieldError">{errors.tipo}</div>
            )}
          </div>
          <div className="AddCliente_itemFieldMercadoPago">
            <label className="AddCliente_itemFieldLabel" htmlFor="permissao">
              Permissão:
            </label>
            <Select
              value={data.permissao}
              defaultValue={data.permissao}
              style={{ border: "1px solid", borderRadius: "4px", width: 288 }}
              onChange={(event) => {
                handleChange("permissao", event);
              }}
            >
              <Option value="VENDA">Vendas</Option>
              <Option value="CORTESIA">Cortesia</Option>
              <Option value="VENDACORTESIA">Venda / Cortesia</Option>
            </Select>
            {errors.tipo && (
              <div className="AddCliente_itemFieldError">{errors.tipo}</div>
            )}
          </div>

          <Button
            className="AddCliente_saveBtn"
            onClick={() => {
              if (!isLoading) onSave();
            }}
            disabled={isLoading}
          >
            SALVAR
          </Button>
        </div>
      </div>
    </>
  );
};

export default EditColaboradorAdmin;
